var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65211 19.7323C3.74195 19.5153 3.89411 19.3299 4.08937 19.1993C4.28462 19.0688 4.5142 18.9991 4.74906 18.9991L10.6866 18.9991L10.6866 7.12407C10.6866 6.49418 10.9368 5.89009 11.3822 5.44469C11.8276 4.99929 12.4317 4.74907 13.0616 4.74907L24.9366 4.74907C25.5665 4.74907 26.1705 4.99929 26.6159 5.44469C27.0613 5.89009 27.3116 6.49418 27.3116 7.12407L27.3116 18.9991L33.2491 18.9991C33.4841 18.9989 33.7138 19.0684 33.9093 19.1989C34.1048 19.3294 34.2571 19.5149 34.3471 19.732C34.437 19.9491 34.4605 20.188 34.4146 20.4185C34.3687 20.649 34.2555 20.8606 34.0892 21.0267L19.8392 35.2767C19.7289 35.3871 19.598 35.4747 19.4538 35.5345C19.3096 35.5942 19.1551 35.625 18.9991 35.625C18.843 35.625 18.6885 35.5942 18.5443 35.5345C18.4002 35.4747 18.2692 35.3871 18.1589 35.2767L3.90891 21.0267C3.74289 20.8606 3.62987 20.6489 3.58416 20.4185C3.53845 20.1881 3.5621 19.9493 3.65211 19.7323Z",
    fill: "#FBFCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternWhiteArrow);
export default __webpack_public_path__ + "static/media/patternWhiteArrow.9621725de79e13677fd75d6d4284d3d0.svg";
export { ForwardRef as ReactComponent };